module.exports = __webpack_public_path__ + "img/Brassica_rapa.c8d9aeb4.jpg";